export const SETTINGS_MENU = 'SETTINGS_MENU';
export const LANGUAGE_MENU = 'LANGUAGE_MENU';
